module.exports = __webpack_public_path__ + "img/willing-risk-taker.28603246.svg";